import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Form, Button, CloseButton } from 'react-bootstrap';
import styles from './modal-merchant-creation.module.scss';

function ModalMerchantCreationComponent(props) {
    return (
        <Modal show={props.showModal} onHide={() => props.hideModal(false)} centered={true}>
            <Modal.Header className={styles.merchantCreationTitle}>
                <span>Create merchant </span>
                <CloseButton onClick={() => props.hideModal(false)} />
            </Modal.Header>
            <Form>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Merchant name:</Form.Label>
                        <Form.Control
                            type="text"
                            isValid={props.validationMessage.isValid}
                            isInvalid={!props.validationMessage.isValid}
                            value={props.merchantName}
                            onChange={props.setMerchantName}
                        />
                        <Form.Text className="invalid-feedback">{props.validationMessage.message}</Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    {!props.isLoading ? (
                        <Button
                            type="submit"
                            disabled={!props.validationMessage.isValid}
                            onClick={props.createMerchant}
                        >
                            Submit
                        </Button>
                    ) : (
                        <button className="btn btn-primary" type="submit" disabled>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span className="ml-2">Loading...</span>
                        </button>
                    )}
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

ModalMerchantCreationComponent.propTypes = {
    showModal: PropTypes.bool,
    hideModal: PropTypes.func,
    merchantName: PropTypes.string,
    setMerchantName: PropTypes.func,
    validationMessage: PropTypes.object,
    createMerchant: PropTypes.func,
    isLoading: PropTypes.bool,
    validateMerchantNameIsUnique: PropTypes.func,
};

export default ModalMerchantCreationComponent;
